import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AmlTraceListRequest } from '@/api';
import { AmlTraceHistoryData } from '../models';

export interface AmlTraceHistorySliceState {
  data: AmlTraceHistoryData;
  loading: boolean;
  error: string | null;
}

const initialState: AmlTraceHistorySliceState = {
  data: null,
  loading: false,
  error: null,
};

const amlTraceHistorySlice = createSlice({
  name: 'amlTraceHistory',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<AmlTraceHistoryData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchTraceHistory: (
      state,
      _action: PayloadAction<AmlTraceListRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
    addData: (state, action: PayloadAction<AmlTraceHistoryData>) => {
      if (action.payload === null) {
        return {
          ...state,
          data: null,
        };
      }

      const currentItems = JSON.parse(JSON.stringify(state.data?.items || []));
      const { items, ...newData } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          ...newData,
          items: [...currentItems, ...items],
        },
      };
    },
  },
});

export { amlTraceHistorySlice };
